import styled from "styled-components";

import { flex } from "../../../helpers/mixins";
import { fromThemeProps } from "../../../helpers/utilities";

const StyledRow = styled.div`
    position: relative;
    ${flex({ jc: "center", ai: "center" })};
    padding: 2em 0;
    padding-top: ${props => props.paddingTop};
    width: 100%;
    max-width: 46em;
`

export default StyledRow;


// WEBPACK FOOTER //
// ./src/styles/styledComponents/blocks/styledRow.js